/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract Receipt",
                name: "dNFTContract",
                type: "address",
            },
            {
                internalType: "contract Receipt",
                name: "rNFTContract",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receivedTokenAddress",
                type: "address",
            },
        ],
        name: "InvalidReceiptContract",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "DepositReceiptReceived",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "RedeemReceiptReceived",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "callMintDepositReceipt",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506040516103db3803806103db83398101604081905261002f9161007c565b600080546001600160a01b039384166001600160a01b031991821617909155600180549290931691161790556100af565b80516001600160a01b038116811461007757600080fd5b919050565b6000806040838503121561008f57600080fd5b61009883610060565b91506100a660208401610060565b90509250929050565b61031d806100be6000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c8063150b7a021461003b57806326595e481461006b575b600080fd5b61004e6100493660046101d6565b610080565b6040516001600160e01b0319909116815260200160405180910390f35b61007e610079366004610271565b610151565b005b600080546001600160a01b031633036100d7577f58ee492df03324b453e59d75f0053dcad5c1f1c3b5aa01ee5695b61fd357d7dc86868686866040516100ca959493929190610293565b60405180910390a161013f565b6001546001600160a01b03163303610120577fc196d0a2d6f246cc102e3206078fffaaef84ec53e5c617f2f4e5c21146dbae6486868686866040516100ca959493929190610293565b60405163500601a960e11b815233600482015260240160405180910390fd5b50630a85bd0160e11b95945050505050565b6000546040516340c10f1960e01b81526001600160a01b03838116600483015260016024830152909116906340c10f1990604401600060405180830381600087803b15801561019f57600080fd5b505af11580156101b3573d6000803e3d6000fd5b5050505050565b80356001600160a01b03811681146101d157600080fd5b919050565b6000806000806000608086880312156101ee57600080fd5b6101f7866101ba565b9450610205602087016101ba565b935060408601359250606086013567ffffffffffffffff8082111561022957600080fd5b818801915088601f83011261023d57600080fd5b81358181111561024c57600080fd5b89602082850101111561025e57600080fd5b9699959850939650602001949392505050565b60006020828403121561028357600080fd5b61028c826101ba565b9392505050565b6001600160a01b038681168252851660208201526040810184905260806060820181905281018290526000828460a0840137600060a0848401015260a0601f19601f8501168301019050969550505050505056fea264697066735822122091fc431985da07f6b9f70fc8045ed1a4372f67221576b528e07f2726025d979a64736f6c63430008180033";
const isSuperArgs = (xs) => xs.length > 1;
export class ReceiptReceiverImpl__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(dNFTContract, rNFTContract, overrides) {
        return super.getDeployTransaction(dNFTContract, rNFTContract, overrides || {});
    }
    deploy(dNFTContract, rNFTContract, overrides) {
        return super.deploy(dNFTContract, rNFTContract, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
ReceiptReceiverImpl__factory.bytecode = _bytecode;
ReceiptReceiverImpl__factory.abi = _abi;
//# sourceMappingURL=ReceiptReceiverImpl__factory.js.map